// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialCurrencyState,
    CurrencySchema,
    CurrencyFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const Currency = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [currency, setCurrency] = useState(InitialCurrencyState);

    const getCurrency = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.CURRENCIES + `/${id}`);
        const data = await response.json();
        setCurrency(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewCurrency = values.id === undefined;
        const url = isNewCurrency ? EntityConstants.CURRENCIES : EntityConstants.CURRENCIES + `/${values.id}`;
        const method = isNewCurrency ? post : put;
        const response = await method(url, { currency: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewCurrency ? MessageContants.CURRENCY_CREATED : MessageContants.CURRENCY_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        if (id !== undefined) {
            getCurrency(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={currency}
            validationSchema={CurrencySchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {CurrencyFormFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.CURRENCY_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.CURRENCY_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

Currency.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default Currency;
